module.exports = __webpack_public_path__ + "static/portfolio_gallery_32-50f89dd2d9713fa47890d682038f7c55.jpg";